import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PlayCircle, Film } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const videoIzleUrl = (id) => `${API}/videolar/${id}/izle`;

export const EgitimVideolari = () => {
  const [videolar, setVideolar] = useState([]);
  const [secili, setSecili] = useState(null);
  const [yuklendi, setYuklendi] = useState(false);

  useEffect(() => {
    axios.get(`${API}/videolar`)
      .then(({ data }) => { setVideolar(data); setSecili(data[0] || null); })
      .catch((e) => console.error('Videolar alınamadı', e))
      .finally(() => setYuklendi(true));
  }, []);

  if (yuklendi && videolar.length === 0) {
    return (
      <div className="aspect-video bg-slate-900 rounded-xl flex items-center justify-center" data-testid="video-bos">
        <div className="text-center">
          <Film className="w-14 h-14 text-slate-600 mx-auto mb-3" />
          <p className="text-slate-400 text-lg">Video Yakında Eklenecek</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-4" data-testid="egitim-videolari">
      <ol className="bg-slate-900/60 rounded-xl border border-slate-700 divide-y divide-slate-700/70 max-h-[480px] overflow-y-auto order-2 lg:order-1" data-testid="video-listesi">
        {videolar.map((v, i) => {
          const aktif = secili?.id === v.id;
          return (
            <li key={v.id}>
              <button
                onClick={() => setSecili(v)}
                className={`w-full text-left px-4 py-3 flex gap-3 transition-colors ${aktif ? 'bg-emerald-600/20 border-l-2 border-emerald-400' : 'hover:bg-slate-800 border-l-2 border-transparent'}`}
                data-testid={`video-item-${i}`}
              >
                <PlayCircle className={`w-5 h-5 mt-0.5 shrink-0 ${aktif ? 'text-emerald-400' : 'text-slate-500'}`} />
                <div className="min-w-0">
                  <div className={`text-sm font-semibold truncate ${aktif ? 'text-white' : 'text-slate-200'}`}>{i + 1}. {v.baslik}</div>
                  {v.aciklama && <div className="text-xs text-slate-400 line-clamp-2 mt-0.5">{v.aciklama}</div>}
                </div>
              </button>
            </li>
          );
        })}
      </ol>
      <div className="order-1 lg:order-2">
        {secili && (
          <>
            <video
              key={secili.id}
              src={videoIzleUrl(secili.id)}
              controls
              preload="metadata"
              className="w-full aspect-video bg-black rounded-xl"
              data-testid="video-player"
            />
            <h3 className="text-white font-semibold mt-3" data-testid="video-baslik">{secili.baslik}</h3>
            {secili.aciklama && <p className="text-slate-400 text-sm mt-1">{secili.aciklama}</p>}
          </>
        )}
      </div>
    </div>
  );
};
